// extracted by mini-css-extract-plugin
module.exports = {"errorsBody":"ModalListErrors_errorsBody__5Wy26"};